import React from 'react';
let DnsRecord = require('./dns_record');

/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.records - the records in the set, each as {type, value, hints}.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.show_header - true iff you want to display the header row.
 */
class DnsRecordSet extends React.Component {
  render() {
    var header;
    if (this.props.show_header) {
      let ttl_header = this.props.show_ttl ? <div className="dns-ttl">TTL</div> : <div></div>;
      header = (
        <div className="dns-records-header">
          <div className="dns-domain">Domain</div>
          <div className="dns-type">Type</div>
          {ttl_header}
          <div className="dns-value">Value</div>
          <div style={{display: 'block', clear: 'both', float: 'none'}}></div>
        </div>
      );
    }
    var key = 0;
    let records = _.map(this.props.records, (record) => (
      <DnsRecord key={key++} domain={this.props.domain} type={record['type']} ttl={record['ttl']} value={record['value']} hints={record['hints']} show_ttl={this.props.show_ttl}/>
    ));

    return (
      <div className="dns-records">
        {header}
        {records}
      </div>
    );
  }
}

module.exports = DnsRecordSet;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/host_helper/dns_record_set.jsx